import { get, post, del } from "../common/apiClient";

const PATH_EXAM = "/exam";

const insertOrUpdateExam = async (body) => {
  return await post(PATH_EXAM, body);
};

const getExams = async (pageNumber, limit = 6, searchQuery, subject, type) => {
  const params = new URLSearchParams();
  params.append("page", pageNumber);
  params.append("limit", limit);
  if (searchQuery) {
    params.append("q", searchQuery);
  }
  if (subject) {
    params.append("subject", subject);
  }
  if (type) {
    params.append("type", type);
  }

  return await get(`${PATH_EXAM}?${params.toString()}`);
};
const activeExam = async (examId) => {
  return await post(PATH_EXAM + `/active/${examId}`);
};
const deleteExam = async (examId) => {
  return await del(PATH_EXAM + `/${examId}`);
};


const getExamDetail = async (id) => {
  return await get(PATH_EXAM + `/${id}`);
};


const getExamsMutiSearch = async (examId) => {
  return await get(PATH_EXAM + `/exams-muti-search`);
};
const totalExams = async () => {
  return await get(PATH_EXAM + `/total`);
};

const getExamByIds = async (body) => {
  return await post(PATH_EXAM + `/ids`, body);
};
export {
  insertOrUpdateExam,
  getExams,
  activeExam,
  deleteExam,
  totalExams,
  getExamsMutiSearch,
  getExamByIds,
  getExamDetail
};
